import { useEffect } from "react";
import {
  destroySmoothScroll,
  initSmoothScroll,
  setIntroActive,
} from "../utils/smoothScroll";
import { useLoaderComplete } from "../utils/useLoaderComplete";

/**
 * Boots Lenis smooth scrolling and keeps the page still until the intro
 * preloader is done, so the hero choreography cannot be scrolled away.
 */
const SmoothScroll = () => {
  const loaderComplete = useLoaderComplete();

  useEffect(() => {
    initSmoothScroll();
    return () => destroySmoothScroll();
  }, []);

  useEffect(() => {
    setIntroActive(!loaderComplete);
  }, [loaderComplete]);

  return null;
};

export default SmoothScroll;
